import React from "react";
import { getInitialsUser } from "../../../assets/helperFunctions";
import CustomAvatar from "../CustomAvatar/CustomAvatar";
import CustomBox from "../CustomBox/CustomBox";
import { CustomStarIcon } from "../CustomIcon/CustomIcon";
import { useStyles } from "../../../assets/jss/PraisoTable";
import clsx from "clsx";

export default function Initials(props) {
  const classes = useStyles();
  return (
    <>
      {props ? (
        <CustomBox className={clsx(classes.avatarContainer)}>
          {props.nameArray ? (
            <CustomAvatar className={classes.avatar}>
              {getInitialsUser({
                nameArray: props.nameArray,
              })}
            </CustomAvatar>
          ) : null}
          {props.score
            ? parseInt(props.score) >= 95 && (
                <CustomStarIcon className={classes.star} />
              )
            : null}
        </CustomBox>
      ) : null}
    </>
  );
}
